<template>
  <modal :modal-key="'resubscribe_modal'"
         :class-style="'modal--welcomeback modal--zero-balance'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal,
        'home_modals_resubscribe_successfully_unsubscribe_msg') }}</h1>
      <img class="usericon" src="static/images/sad.svg" alt="">
    </template>
    <template slot="body">
      {{ getTranslations.home_modals_resubscribe_reactivate_account_msg_new }}
    </template>
    <template slot="footer" v-if="!existThisPathInForbiddenPages('/resubscribeSteps')">
      <a>
        <div class="btn2 btn2--std btn2--small btn2--fixed" @click.prevent="reOptin">
          {{ getTranslations.home_modals_resubscribe_resubscribe_new }}
        </div>
      </a>
      <span class="terms">
          {{ getTranslations.home_modals_resubscribe_by_clicking }}
          <br>
          <a style="cursor:pointer"
             :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')"
             target="_blank">{{ getTranslations.home_modals_resubscribe_t_and_cs }}</a>
          {{ getTranslations.home_modals_resubscribe_of_the_service }}
        </span>
    </template>
  </modal>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import WelcomeReturningUnsub from './WelcomeReturningUnsub';
import ResubscribeViaPin from './ResubscribeViaPin';
import ResubscribeError from './ConfirmPurchaseForPinError';

export default {
  // It is correct (the name is from previous versions): modal_unsubscribe_confirmation.html
  name: 'resubscribe',
  components: {
    WelcomeReturningUnsub,
    ResubscribeViaPin,
    Modal,
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForSettings',
    ]),
    ...mapActions('common', [
      'reOptinProcess',
    ]),
    reSubCallback(response) {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        this.getUserLoginDetails().then(() => {
          if (this.reoptinOnestep) {
            if (this.userDetails.subscribed) {
              this.storeModalForSettings(WelcomeReturningUnsub);
            } else {
              this.storeModalForSettings(ResubscribeError);
            }
          } else {
            // eslint-disable-next-line
            if (this.userDetails.subscribed) {
              this.storeModalForSettings(ResubscribeError);
            } else {
              this.storeModalForSettings(ResubscribeViaPin);
            }
          }
        });
      } else {
        this.storeModalForSettings(ResubscribeError);
      }
    },
    reOptin() {
      this.getAppropriateReSubAction();
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'multiOperatorInfo',
      'reoptinOnestep',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
    ...mapGetters('common', [
      'existThisPathInForbiddenPages',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/Resubscribe.vue